import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a4ece4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "assignment" }
const _hoisted_2 = {
  key: 0,
  id: "assignmentLoadingDiv",
  class: "loadingDiv1",
  style: {"padding":"5px"}
}
const _hoisted_3 = {
  id: "actionable-content-loading",
  style: {"text-align":"center"}
}
const _hoisted_4 = { class: "fa-2x" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Saving...")
], -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col txtLeft" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-subtitle mb-3 text-muted" }
const _hoisted_10 = { class: "font-weight-bold" }
const _hoisted_11 = { class: "card-subtitle mb-3 text-muted" }
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = { class: "font-weight-bold" }
const _hoisted_14 = { class: "font-weight-bold" }
const _hoisted_15 = { class: "font-weight-bold" }
const _hoisted_16 = { class: "row-padding" }
const _hoisted_17 = { "aria-hidden": "true" }
const _hoisted_18 = { class: "neu-tooltip--text tooltipTxt" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "assignment-view" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "mx-5" }
const _hoisted_24 = { class: "progress-indicator" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bubble" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bubble" }, null, -1))
const _hoisted_27 = { class: "edit-step-1" }
const _hoisted_28 = { class: "assignment-edit txtLeft" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_30 = { class: "actions" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-sm" }
const _hoisted_33 = { class: "col-sm" }
const _hoisted_34 = { class: "edit-step-2" }
const _hoisted_35 = {
  key: 0,
  class: "assignment-edit-original"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_37 = {
  key: 1,
  class: "assignment-edit-review"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_39 = { class: "actions" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-sm" }
const _hoisted_42 = { class: "col-sm" }
const _hoisted_43 = {
  key: 4,
  id: "assignment-split"
}
const _hoisted_44 = { class: "mx-5" }
const _hoisted_45 = { class: "progress-indicator" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bubble" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bubble" }, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bubble" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bubble" }, null, -1))
const _hoisted_50 = { class: "split-step-1" }
const _hoisted_51 = { class: "row justify-content-center" }
const _hoisted_52 = { class: "col" }
const _hoisted_53 = { class: "form-group row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-5 col-form-label text-end font-weight-bold" }, "Split Time", -1))
const _hoisted_55 = { class: "col txtLeft" }
const _hoisted_56 = {
  key: 1,
  class: "requiredTimerTxt"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_58 = { class: "actions" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-sm" }
const _hoisted_61 = { class: "col-sm" }
const _hoisted_62 = { class: "split-step-2" }
const _hoisted_63 = { class: "assignment-splitA txtLeft" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_65 = { class: "actions" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-sm" }
const _hoisted_68 = { class: "col-sm" }
const _hoisted_69 = { class: "split-step-3" }
const _hoisted_70 = { class: "assignment-splitB txtLeft" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_72 = { class: "actions" }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-sm" }
const _hoisted_75 = { class: "col-sm" }
const _hoisted_76 = { class: "split-step-4" }
const _hoisted_77 = {
  key: 0,
  class: "assignment-split-original"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_79 = {
  key: 1,
  class: "assignment-splitA-review"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_81 = {
  key: 2,
  class: "assignment-splitB-review"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_83 = { class: "actions" }
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-sm" }
const _hoisted_86 = { class: "col-sm" }
const _hoisted_87 = { key: 5 }
const _hoisted_88 = { class: "mx-5" }
const _hoisted_89 = { class: "progress-indicator" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bubble" }, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bubble" }, null, -1))
const _hoisted_92 = { class: "create-step-1" }
const _hoisted_93 = { class: "assignment-create txtLeft" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_95 = { class: "actions" }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-sm" }
const _hoisted_98 = { class: "col-sm" }
const _hoisted_99 = { class: "edit-step-2" }
const _hoisted_100 = {
  key: 0,
  class: "assignment-create-review"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_102 = { class: "actions" }
const _hoisted_103 = { class: "row" }
const _hoisted_104 = { class: "col-sm" }
const _hoisted_105 = { class: "col-sm" }
const _hoisted_106 = { key: 6 }
const _hoisted_107 = { key: 7 }
const _hoisted_108 = { key: 8 }
const _hoisted_109 = { key: 9 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_AssignmentView = _resolveComponent("AssignmentView")!
  const _component_AssignmentCancel = _resolveComponent("AssignmentCancel")!
  const _component_AssignmentEdit = _resolveComponent("AssignmentEdit")!
  const _component_AssignmentEditReview = _resolveComponent("AssignmentEditReview")!
  const _component_vue_timepicker = _resolveComponent("vue-timepicker")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_FeedbackSnackbar = _resolveComponent("FeedbackSnackbar")!
  const _component_CareAssignment = _resolveComponent("CareAssignment")!
  const _component_ExportToExcelForTabs = _resolveComponent("ExportToExcelForTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isShowSavingLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_font_awesome_icon, {
                spin: true,
                icon: ['fas', 'circle-notch'],
                size: "lg"
              })
            ]),
            _hoisted_5
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("h5", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(_ctx.EmployeeName), 1)
        ]),
        _withDirectives(_createElementVNode("h6", _hoisted_9, [
          _createTextVNode(" Phone:"),
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'phone'],
            size: "sm",
            class: "ml-1"
          }),
          _createTextVNode("  "),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.PhoneNumber), 1),
          _createTextVNode("  ")
        ], 512), [
          [_vShow, _ctx.showPhoneNumber]
        ]),
        _withDirectives(_createElementVNode("h6", _hoisted_11, [
          _createTextVNode(" Shift: "),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.ShiftCode), 1),
          _createTextVNode("  "),
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'calendar'],
            size: "sm"
          }),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.shiftDate), 1),
          _createTextVNode("  "),
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', 'clock'],
            size: "sm"
          }),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.StartTime), 1),
          _createTextVNode(" - "),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.EndTime), 1)
        ], 512), [
          [_vShow, _ctx.showShiftHeader]
        ])
      ], 512), [
        [_vShow, _ctx.showHeader]
      ]),
      _createElementVNode("div", _hoisted_16, [
        (_ctx.isShowTrainingLink && _ctx.profileData.TrainingEnabled)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              class: "modaltoolbarIcon neu-tooltip",
              style: {"cursor":"pointer","color":"#3673AA"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fnOpenVideo && _ctx.fnOpenVideo(...args)))
            }, [
              _createElementVNode("span", _hoisted_17, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'fa-video'],
                  size: "lg"
                }),
                _createTextVNode(" Learn How ")
              ]),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.trainingLinkToolTip), 1)
            ]))
          : _createCommentVNode("", true),
        _createTextVNode("   "),
        _withDirectives(_createVNode(_component_neu_button, {
          type: "button",
          fill: "raised",
          id: "assignment_edit_btn",
          onClick: _ctx.formOnEdit,
          class: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'edit'],
              size: "sm",
              class: "mr-2"
            }),
            _createTextVNode(" Edit ")
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.showEditButton]
        ]),
        _withDirectives(_createVNode(_component_neu_button, {
          type: "button",
          fill: "raised",
          id: "assignment_cancel_btn",
          disabled: !_ctx.enabledCancelButton,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.enabledCancelButton ? null : _ctx.formOnCancel())),
          class: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'minus-circle'],
              size: "sm",
              class: "mr-2"
            }),
            _createTextVNode(" Cancel ")
          ]),
          _: 1
        }, 8, ["disabled"]), [
          [_vShow, _ctx.showCancelButton]
        ]),
        _withDirectives(_createVNode(_component_neu_button, {
          type: "button",
          fill: "raised",
          id: "assignment_split_btn",
          disabled: !_ctx.enabledSplitButton,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.enabledSplitButton ? null : _ctx.formOnSplit())),
          class: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'clone'],
              size: "sm",
              class: "mr-2"
            }),
            _createTextVNode(" Split ")
          ]),
          _: 1
        }, 8, ["disabled"]), [
          [_vShow, _ctx.showSplitButton]
        ]),
        _createVNode(_component_neu_button, {
          type: "button",
          fill: "raised",
          id: "assignment_back_btn",
          onClick: _ctx.formOnClose,
          class: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'arrow-circle-left'],
              size: "sm",
              class: "mr-2"
            }),
            _createTextVNode(" Back to Assignments ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.showView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_AssignmentView, { assignmentViewInput: _ctx.assignmentInput }, null, 8, ["assignmentViewInput"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCancel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_AssignmentCancel, { assignmentCancelInput: _ctx.assignmentInput }, null, 8, ["assignmentCancelInput"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("ul", _hoisted_24, [
              _createElementVNode("li", {
                class: _normalizeClass([_ctx.isEditStep ? 'active' : '', _ctx.isEditReviewStep ? 'completed' : ''])
              }, [
                _hoisted_25,
                _createTextVNode(" Edit Assignment ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass([_ctx.isEditReviewStep ? 'active' : ''])
              }, [
                _hoisted_26,
                _createTextVNode(" View Summary ")
              ], 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_AssignmentEdit, {
                assignmentEditInput: _ctx.assignmentInput,
                containerType: "editAssignment"
              }, null, 8, ["assignmentEditInput"])
            ]),
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.editFormOnExit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-left'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Previous ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "next_btn",
                    onClick: _ctx.editFormOnReview
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-right'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Next ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isEditStep]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_34, [
            (_ctx.showAssignmentEditOriginal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createVNode(_component_AssignmentEditReview, { assignmentReviewInput: _ctx.assignmentOriginalData }, null, 8, ["assignmentReviewInput"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_36,
            (_ctx.showAssignmentEditReview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_AssignmentEditReview, { assignmentReviewInput: _ctx.modifiedAssignment }, null, 8, ["assignmentReviewInput"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives(_createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.editFormOnEdit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-left'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Previous ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, _ctx.showEditFormPrevious]
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "next_btn",
                    onClick: _ctx.editFormOnSave
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'save'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Save & Finish ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, _ctx.showEditFormOnSave]
                  ])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isEditReviewStep]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSplit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("ul", _hoisted_45, [
              _createElementVNode("li", {
                class: _normalizeClass([_ctx.isSplitTimeStep ? 'active' : '', _ctx.isSplitTimeStepComplete ? 'completed' : ''])
              }, [
                _hoisted_46,
                _createTextVNode(" Split Time ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass([_ctx.isSplitStep1 ? 'active' : '', _ctx.isSplitStep1Complete ? 'completed' : ''])
              }, [
                _hoisted_47,
                _createTextVNode(" Assignment A ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass([_ctx.isSplitStep2 ? 'active' : '', _ctx.isSplitStep2Complete ? 'completed' : ''])
              }, [
                _hoisted_48,
                _createTextVNode(" Assignment B ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass([_ctx.isSplitReviewStep ? 'active' : '', _ctx.isSplitReviewStepComplete ? 'completed' : ''])
              }, [
                _hoisted_49,
                _createTextVNode(" View Summary ")
              ], 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, [
                    (_openBlock(), _createBlock(_component_vue_timepicker, {
                      "hour-range": _ctx.hourRange,
                      format: "h:mm A",
                      modelValue: _ctx.SplitTime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.SplitTime) = $event)),
                      key: _ctx.counterSplitTime,
                      onClose: _ctx.splitTimeValidation,
                      "minute-interval": _ctx.SplitInterval,
                      "auto-scroll": "",
                      "manual-input": "",
                      "hide-disabled-items": "",
                      "close-on-complete": ""
                    }, null, 8, ["hour-range", "modelValue", "onClose", "minute-interval"])),
                    (_ctx.isShowSplitTimerRequired)
                      ? (_openBlock(), _createBlock(_component_neu_icon, {
                          key: 0,
                          class: "timerRequired material-icons",
                          "aria-hidden": "true"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("error")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isShowSplitTimerRequired)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.splitTimerErrorTxt), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _hoisted_57,
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.splitFormOnExit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-left'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Previous ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "next_btn",
                    onClick: _ctx.splitFormOnSplitTimeComplete
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-right'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Next ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isSplitTimeStep]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              (_openBlock(), _createBlock(_component_AssignmentEdit, {
                assignmentEditInput: _ctx.assignmentsplitAInput,
                containerType: "splitAAssignment",
                key: _ctx.refershSplitAAssignmentCompCounter
              }, null, 8, ["assignmentEditInput"]))
            ]),
            _hoisted_64,
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.splitFormOnPrevious
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-left'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Previous ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "next_btn",
                    onClick: _ctx.splitFormOnSplitAComplete
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-right'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Next ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isSplitStep1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              (_openBlock(), _createBlock(_component_AssignmentEdit, {
                assignmentEditInput: _ctx.assignmentsplitBInput,
                containerType: "splitBAssignment",
                key: _ctx.refershSplitBAssignmentCompCounter
              }, null, 8, ["assignmentEditInput"]))
            ]),
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.splitFormOnPrevious
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-left'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Previous ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "next_btn",
                    onClick: _ctx.splitFormOnSplitBComplete
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-right'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Next ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isSplitStep2]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_76, [
            (_ctx.showAssignmentSplitOriginal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  _createVNode(_component_AssignmentEditReview, { assignmentReviewInput: _ctx.assignmentOriginalData }, null, 8, ["assignmentReviewInput"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_78,
            (_ctx.showAssignmentSplitAssignA)
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  _createVNode(_component_AssignmentEditReview, { assignmentReviewInput: _ctx.modifiedassignmentsplitAInput }, null, 8, ["assignmentReviewInput"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_80,
            (_ctx.showAssignmentSplitAssignB)
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                  _createVNode(_component_AssignmentEditReview, { assignmentReviewInput: _ctx.modifiedassignmentsplitBInput }, null, 8, ["assignmentReviewInput"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_82,
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _withDirectives(_createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.splitFormOnPrevious
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-left'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Previous ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, _ctx.showSplitFormPrevious]
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _withDirectives(_createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.splitFormOnSave
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'save'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Save & Finish ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, _ctx.showSplitFormOnSave]
                  ])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isSplitReviewStep]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCreate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("ul", _hoisted_89, [
              _createElementVNode("li", {
                class: _normalizeClass([_ctx.isCreateStep ? 'active' : '', _ctx.isCreateReviewStep ? 'completed' : ''])
              }, [
                _hoisted_90,
                _createTextVNode(" Create Assignment ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass([_ctx.isCreateReviewStep ? 'active' : ''])
              }, [
                _hoisted_91,
                _createTextVNode(" View Summary ")
              ], 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createVNode(_component_AssignmentEdit, {
                assignmentEditInput: _ctx.assignmentInput,
                containerType: "createAssignment"
              }, null, 8, ["assignmentEditInput"])
            ]),
            _hoisted_94,
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.createFormOnExit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-left'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Previous ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "next_btn",
                    onClick: _ctx.createFormOnReview
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-right'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Next ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isCreateStep]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_99, [
            (_ctx.showAssignmentCreateOriginal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                  _createVNode(_component_AssignmentEditReview, { assignmentReviewInput: _ctx.modifiedCreateAssignment }, null, 8, ["assignmentReviewInput"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_101,
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _withDirectives(_createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "prev_btn",
                    onClick: _ctx.createFormOnEdit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'angle-left'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Previous ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, _ctx.showCreateFormPrevious]
                  ])
                ]),
                _createElementVNode("div", _hoisted_105, [
                  _withDirectives(_createVNode(_component_neu_button, {
                    type: "button",
                    fill: "raised",
                    name: "next_btn",
                    onClick: _ctx.createFormOnSave
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['fas', 'save'],
                        size: "sm",
                        class: "mr-2"
                      }),
                      _createTextVNode(" Save & Finish ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, _ctx.showCreateFormOnSave]
                  ])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isCreateReviewStep]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAlertVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
          _createVNode(_component_FeedbackSnackbar, {
            onCloseModal: _ctx.closeAlertPopup,
            msgValue: _ctx.msgValueAlert,
            classFlag: _ctx.classFlagAlert
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowCareAssignmentSheetPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
          _createVNode(_component_CareAssignment, {
            onClosePrintTemplate: _ctx.closeCareAssignmentSheetPopup,
            payloadCareAssignment: _ctx.payloadCareAssignment
          }, null, 8, ["onClosePrintTemplate", "payloadCareAssignment"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowExportToExcel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
          _createVNode(_component_ExportToExcelForTabs, {
            onCloseExcelTemplate: _ctx.closeHomeTabExportToExcel,
            payloadExportToExcel: _ctx.payloadExportToExcel
          }, null, 8, ["onCloseExcelTemplate", "payloadExportToExcel"])
        ]))
      : _createCommentVNode("", true)
  ]))
}